module.exports = __webpack_public_path__ + "assets/images/24-2AoZMYB.jpg";